<template>
    <a href="javascript://void" @click="downloadFile(filepath)" class="btn btn-sm btn-white font-light full-width"
       style="margin:32px auto 18px auto;">
        Download
        <i class="fa fa-download" aria-hidden="true"></i>
    </a>
</template>

<script>
/**
 * Note: Cannot be nested within a form element with a non-https action
 */
export default {
    props: {
        filepath: {
            type: String,
            required: true
        },
    },

    created(){
        this.init();
    },

    data(){
        return {
            loading: false,
        };
    },

    methods: {
        init() {},

        downloadFile(filepath) {
            window.location.href = 'files/multiSignatureDownload'
        },
    }
}
</script>
